import axios from '../../common/interceptor/app.interceptor';

export const fetchSlotsAsync = (url, params, authToken) => {
  return axios({
    method: 'GET',
    url,
    params,
    headers: {
      'Content-Type': 'application/json',
      Authorization: authToken
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

export const bookSlotsAsync = (url, data, authToken) => {
  return axios({
    method: 'POST',
    url,
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: authToken
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

export const rescheduleSlotsAsync = (url, data, authToken) => {
  return axios({
    method: 'POST',
    url,
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: authToken
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};
